import "../style.css";
import React from "react";
import PanelContent from "../components/PanelContent";

export default function VilleLaboratoire() {
  return (
    <PanelContent
      id="campagne_panel"
      route="/routescampagne"
      title="Routes de Campagne"
      subtitle="21 819 m² de surface roulable"
      description="Cette vaste piste représente les routes secondaires d’Europe à travers de larges virages et ses différents marquages. Plusieurs parcours sont utilisables, en passant par deux grands ronds-points et un plateau de comportement. Sur cette piste, il est possible de mettre à l’épreuve la fonction de maintien dans la voie, ou encore de tester différents revêtements plus adhérents."
      prev="/autoroute"
      next="/villelaboratoire"
      txtbtn="ZONE SUIVANTE"
    />
  );
}
